import React from 'react';
import styled from '@emotion/styled';
import { Tag } from '@robinpowered/ui-kit';
import InfoSolid from '@robinpowered/ui-kit-icons/InfoSolid';
import WarningSolid from '@robinpowered/ui-kit-icons/WarningSolid';
import { useTranslation } from 'react-i18next';
import { CheckInStatus } from '../../utils/getReservationActions';

type CheckInStatusTagProps = {
  status: CheckInStatus;
};

export const CheckInStatusTag = ({
  status,
}: CheckInStatusTagProps): JSX.Element | null => {
  const { t } = useTranslation('peopleProfileSidebar', {
    keyPrefix: 'bookings',
  });

  if (
    status !== 'notRequired' &&
    status !== 'localOnly' &&
    status !== 'required'
  ) {
    return null;
  }

  const isNotRequired = status === 'notRequired';
  const icon = isNotRequired ? <InfoSolid /> : <WarningSolid />;
  const iconColor = isNotRequired
    ? 'var(--ant-color-text-secondary)'
    : 'var(--ant-color-warning)';
  const label = isNotRequired
    ? t('checkInNotRequired')
    : status === 'localOnly'
    ? t('localCheckInRequired')
    : t('checkInRequired');

  return (
    <StyledTag icon={<IconSlot $color={iconColor}>{icon}</IconSlot>}>
      <TagText>{label}</TagText>
    </StyledTag>
  );
};

const StyledTag = styled(Tag)`
  display: inline-flex;
  align-self: flex-start;
  flex-wrap: nowrap;
  max-width: 100%;
  height: auto;
  margin: 0;
  padding: 2px 8px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 4px;
  line-height: 1.4;
`;

const IconSlot = styled.span<{ $color: string }>`
  flex: 0 0 auto;
  margin-top: 2px;
  color: ${({ $color }) => $color};
  font-size: 12px;
  display: inline-flex;
  align-items: center;
`;

const TagText = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
  overflow-wrap: break-word;
`;
